module.exports = __webpack_public_path__ + "static/media/WebFormIllustration.921c4d22.svg";